import React, { useState } from 'react';

import type { UserCreateDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';

import Card from '../../../components/common/Card';
import UserForm from '../../../components/forms/UserForm';
import AdminLayout from '../../../components/layout/AdminLayout';
import { useUserApi } from '../../../hooks/useUserApi';

const UserCreate: React.FC = () => {
  const [profilePicture, setProfilePicture] = useState<File | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { create, uploadProfilePicture } = useUserApi();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Users', href: '/admin/users' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: UserCreateDTO): Promise<void> => {
    try {
      setIsSubmitting(true);
      if (profilePicture) {
        // Call the method to upload the logo image
        const uploadResponse = await uploadProfilePicture(
          profilePicture.name,
          profilePicture,
        );

        if (uploadResponse && uploadResponse.success) {
          data.profilePictureFileId = uploadResponse.data;
        }
      }

      const response = await create(data);
      if (response && response.success && response.data) {
        localStorage.removeItem(`profilePic_${response.data?.id}`);
        navigate('/admin/users');
      }
    } catch (error) {
      console.error('Error creating user:', error);
    } finally {
      setIsSubmitting(true);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/users"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
    >
        <UserForm
          initialValues={{} as UserCreateDTO}
          isSubmitting={isSubmitting}
          onSave={handleSubmit}
          setProfilePicture={setProfilePicture}
          onCancel={() => navigate('/admin/users')}
          isCreating
        />
    </AdminLayout>
  );
};

export default UserCreate;
